import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const FOUNDER_USERNAME = "Thewellnesscowgirl";

export function useFounderEventIds() {
  return useQuery({
    queryKey: ["founder-confirmed-event-ids"],
    queryFn: async () => {
      const { data: founder, error: founderError } = await supabase
        .from("profiles")
        .select("id")
        .eq("username", FOUNDER_USERNAME)
        .maybeSingle();

      if (founderError) throw founderError;
      if (!founder) return [] as string[];

      const { data, error } = await supabase
        .from("event_attendances")
        .select("event_id")
        .eq("user_id", founder.id)
        .eq("status", "rsvp");

      if (error) throw error;
      return (data ?? []).map((attendance) => attendance.event_id);
    },
    staleTime: 2 * 60 * 1000,
  });
}